(function () {
  function run() {
    let params = new URLSearchParams(window.location.search);
    let status = params.get('status');

    let section = document.querySelector('.verifycode-section');
    let successEl = section ? section.querySelector('[data-success]') : null;
    let errorEl = section ? section.querySelector('[data-error]') : null;
    let loaderEl = section ? section.querySelector('.main-loader') : null;
    let errorSectionEl = document.querySelector('.verifycode-error-section');

    if (!successEl || !errorEl) return;

    setTimeout(() => {
      if (loaderEl) loaderEl.style.display = 'none';

      if (status === 'success') {
        successEl.style.display = '';
        if (errorEl) errorEl.style.display = 'none';
        if (errorSectionEl) errorSectionEl.style.display = 'none';
      } else if (status === 'error') {
        successEl.style.display = 'none';
        errorEl.style.display = '';
        if (errorSectionEl) errorSectionEl.style.display = 'block';
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
